import React from "react";
import { withStyles } from "@material-ui/styles";
import { size, includes, slice, toLower } from "lodash";

import colors from "../../assets/style/colors";

const styles = {
  highlightedText: {
    backgroundColor: colors.cardGreen20,
    color: colors.black54,
  },
  normalText: {
    color: colors.black54,
    overflowWrap: "anywhere",
  },
};

const HighlightedText = (props) => {
  const { classes, text, highlightText } = props;

  if (includes(toLower(text), toLower(highlightText))) {
    const startIndex = toLower(text).indexOf(toLower(highlightText));
    const endIndex = startIndex + size(highlightText);

    return (
      <>
        <span className={classes.normalText}>{slice(text, 0, startIndex)}</span>
        <span className={classes.highlightedText}>
          {slice(text, startIndex, endIndex)}
        </span>
        <span className={classes.normalText}>{slice(text, endIndex)}</span>
      </>
    );
  }

  return (
    <span className={classes.normalText} style={props.style}>
      {text}
    </span>
  );
};

export default withStyles(styles)(HighlightedText);
